var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelopeSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "envelope-solid 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.8125 7.75C2.60352 7.75 0 10.3535 0 13.5625C0 15.391 0.859766 17.1105 2.325 18.2125L28.675 37.975C30.0555 39.0043 31.9445 39.0043 33.325 37.975L59.675 18.2125C61.1402 17.1105 62 15.391 62 13.5625C62 10.3535 59.3965 7.75 56.1875 7.75H5.8125ZM0 21.3125V46.5C0 50.7746 3.47539 54.25 7.75 54.25H54.25C58.5246 54.25 62 50.7746 62 46.5V21.3125L35.65 41.075C32.8891 43.1457 29.1109 43.1457 26.35 41.075L0 21.3125Z",
    fill: "#AA182C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeSolid);
export default __webpack_public_path__ + "static/media/envelope-solid.3cced5603db5d1471f137faf4f7cf179.svg";
export { ForwardRef as ReactComponent };